import { Identifiers, SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: SectionsKey.ProfileInformation,
    useLayout: true,
    children: [{ id: SectionsKey.ProfileInformation, order: 1, dataKey: SectionsKey.ProfileInformation },
    { id: SectionsKey.BenefitsSection, order: 2, identifier: Identifiers.BenefitsSection },
    { id: SectionsKey.FollowUs, order: 3, identifier: Identifiers.FollowUs }]
};

export default PageStruct;
